import { useEffect, useState, AnchorHTMLAttributes } from "react";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

/**
 * Ulkoinen linkki: sininen ennen klikkausta, violetti klikkauksen jälkeen.
 * Tila tallennetaan localStorageen, joten väri säilyy myös selainhistoriasta riippumatta.
 */
export const ExternalLink = ({ href, children, className = "", onClick, ...rest }: Props) => {
  const storageKey = `lnk:${href}`;
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    try {
      setClicked(localStorage.getItem(storageKey) === "1");
    } catch {
      // ignore
    }
  }, [storageKey]);

  const color = clicked ? "#7e22ce" : "#1d4ed8";

  return (
    <a
      {...rest}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color, ...(rest.style ?? {}) }}
      className={`no-underline hover:opacity-80 ${className}`}
      onClick={(e) => {
        try {
          localStorage.setItem(storageKey, "1");
        } catch {
          // ignore
        }
        setClicked(true);
        onClick?.(e);
      }}
    >
      {children}
    </a>
  );
};
